/**
 * Sizing for third-party logos, which arrive in every proportion there is.
 *
 * A common *height* makes a square badge (Mercedes, Centenary) look small
 * beside a long wordmark (Isuzu, Stanbic); a common *area* makes the two carry
 * the same visual weight. The max width and height then keep either extreme
 * inside its tile.
 */
export type LogoBox = { maxWidth: number; maxHeight: number; area: number };

/** The rendered width and height for a source of `w × h`, fitted to `box`. */
export function fitLogoBox(w: number, h: number, box: LogoBox, scale = 1) {
  const ratio = w / h;
  const maxWidth = box.maxWidth * scale;
  const maxHeight = box.maxHeight * scale;
  const area = box.area * scale * scale;
  const fit = Math.min(1, maxWidth / Math.sqrt(area * ratio), maxHeight / Math.sqrt(area / ratio));
  return {
    width: Math.round(Math.sqrt(area * ratio) * fit),
    height: Math.round(Math.sqrt(area / ratio) * fit),
  };
}
